import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import FilterChip from '@/storybook/components/FilterChip/FilterChip';
import If from '@/storybook/components/If/If';
import { TestIds } from './testIds';
import styles from './AIFilterChips.module.css';

export interface AIFilterChip {
  label: string;
  value: string;
  details?: string;
}

export interface AIFilterChipsProps {
  'filters': ReadonlyArray<AIFilterChip>;
  'className'?: string;
  'data-testid'?: string;
  'trailingSlot'?: ReactNode;
}

const AIFilterChips: FC<AIFilterChipsProps> = ({
  filters,
  className,
  'data-testid': dataTestId = TestIds.list,
  trailingSlot,
}) => {
  const { t } = useTranslation();

  if (filters.length === 0) {
    return null;
  }

  return (
    <ul className={className ? `${styles.list} ${className}` : styles.list} data-testid={dataTestId}>
      {filters.map(filterChip => {
        const ariaLabel = t('components.aiChatDrawer.filterContext.chipAriaLabel', {
          label: filterChip.label,
          value: filterChip.details ?? filterChip.value,
        });

        return (
          <li key={`${filterChip.label}-${filterChip.value}`}>
            <FilterChip
              label={filterChip.value}
              size="S"
              tooltip={filterChip.label}
              aria-label={ariaLabel}
              data-testid={TestIds.chip}
            />
          </li>
        );
      })}
      <If condition={Boolean(trailingSlot)}>
        <li>{trailingSlot}</li>
      </If>
    </ul>
  );
};

export default AIFilterChips;
